import React, { useEffect, useRef, FC, useState } from 'react'
import { Button, Form, message, notification, Upload, Image } from 'antd'
import { YHModal } from '@/components/YHModal'
import { YhFormBox } from '@/components/YhFormBox'
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from '@/components/YhFormBox/Types'
import { ISupplierContractDetails, ISupplierContractInsert } from '@/views/supplier/supplierTypes'
import { useSupplyDetailsMode } from './supplierContractModel'
import { supplierService } from '../../../supplierService'
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from '@/utils/constants'
import FontIcon from '@/components/YhIcon'
import { FileExcelOutlined, UploadOutlined } from '@ant-design/icons'
import { UploadChangeParam } from 'antd/lib/upload'
import { UploadFile } from 'antd/lib/upload/interface'
import moment from 'moment'

export const SupplyDetailsModal: FC<{}> = () => {
    const { modalVisible: visible, modalMode: mode, currentRecord: data, handleClose, loadData, contractTypeOptions } = useSupplyDetailsMode()
    const formRef = useRef<IYhFormRef>()
    const [formValues, setFormValues] = useState<ISupplierContractDetails | ISupplierContractInsert>({})
    const [saveLoading, setSaveLoading] = useState(false)
    const [previewOpen, setPreviewOpen] = useState<boolean>(false)
    const [previewImage, setPreviewImage] = useState<any>()

    const [uploadFileList, setUploadFileList] = useState<any>([])

    // 当弹窗打开且有数据时，设置表单值
    useEffect(() => {
        if (visible && data) {
            const {signDate, deadline, attachment} = data
            let attachmentList: UploadFile[] = []
            if (mode === 'add') {
                setUploadFileList([])
            }
            if (mode !== 'add' && attachment) {
                attachmentList = [{
                    name: '附件',
                    uid: attachment,
                    // md5: attachment,
                    status: 'done',
                    url: getBaseImgLookUrl(attachment),
                    size:0,
                    type:''
                }]
            }   
                setUploadFileList(attachmentList)
              setFormValues({...data, signDate: moment(signDate), deadline: moment(deadline), fileList: attachmentList})
        } else {
            setFormValues({})
        }
    }, [visible, data])

    // 表单change事件
    const onChange = (changedValues: { [key: string]: any }, values: ISupplierContractDetails) => {
        setFormValues(values)
    }

    // 保存操作
    const handleSave = () => {
        if (mode === 'view') {
            handleClose()
            return
        }
        formRef.current
            ?.validateFields()
            .then(async (values) => {
                setSaveLoading(true)
                const { signDate, deadline, fileList, ...info} = values
                let param = { ...data, ...info, signDate: moment(signDate).format('YYYY-MM-DD'), deadline: moment(deadline).format('YYYY-MM-DD') }
                param.validityDays =  moment(deadline).diff(moment(signDate), 'days')
                if (uploadFileList.length > 0) {
                    param.attachment = uploadFileList[0].uid
                }
                if (mode === 'add') {
                    let { retData } = await supplierService.supplierContractInsert(param)
                    if (retData) {
                        setSaveLoading(false)
                        message.success('保存成功！')
                        handleClose()
                    }
                } else {
                    let { retData } = await supplierService.supplierContractUpdate(param)
                    if (retData) {
                        setSaveLoading(false)
                        message.success('保存成功！')
                        handleClose()
                    }
                }

                loadData()
            })
            .catch(() => {
                setSaveLoading(false)
                loadData()
            })
    }

    const normFile = (e: UploadChangeParam) => {
        let filetypes: string[] = ['.jpg', '.png', '.jpeg', 'svg', '.gif', '.pdf', '.doc', '.xls', '.xlsx']
        let isType: boolean = false
        let fileEnd: string = e?.file.name.substring(e?.file.name.lastIndexOf('.'))
        isType = filetypes?.includes(fileEnd) ?? false
        console.log('Upload event:', e)
        if (e?.file.status === 'done') {
            if (e?.file.response.retCode == 0) {
                const data = {
                    name: e.file.name,
                    size: e.file.size,
                    type: e.file.type,
                    uid: e.file.response.retData,
                    md5: e.file.response.retData,
                    url: getBaseImgLookUrl(e.file.response.retData),
                }
                e.fileList[e.fileList.length - 1] = data
            } else {
                message.error('文件上传失败，请重新上传!')
                e.fileList?.pop()
            }
        }
        if (e.file.status === 'error') {
            message.error('文件上传失败，请重新上传!')
            e.fileList?.pop()
        }
        if (Array.isArray(e)) {
            return e
        }
        if (!isType) {
            e.fileList?.pop()
        }
        return e && e.fileList
    }

    // 表单配置
    const baseFormItem: IYhFormItemsBox = {
        style: { padding: '10px 0 0 0', marginBottom: '15px' },
        contentClass: 'pr-77',
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '合同编号',
                fieldName: 'contractCode',
                disable: mode === 'view',
                span: 12,
                rules: [{ required: true, message: '请输入合同编号' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '供应商编号',
                fieldName: 'supplierCode',
                disable: true,
                span: 12,
                rules: [{ required: true, message: '请输入供应商编号' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '供应商名称',
                fieldName: 'supplierName',
                disable: true,
                span: 12,
                rules: [{ required: true, message: '请输入供应商名称' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '甲方签约人',
                fieldName: 'partyASigner',
                disable: mode === 'view',
                span: 12,
                rules: [{ required: true, message: '请输入甲方签约人' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '乙方签约单位',
                fieldName: 'partyBUnit',
                disable: mode === 'view',
                span: 12,
                rules: [{ required: true, message: '请输入乙方签约单位' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '乙方签约人',
                fieldName: 'partyBSigner',
                disable: mode === 'view',
                span: 12,
                rules: [{ required: true, message: '请输入乙方签约人' }],
            },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: '签约日期',
                fieldName: 'signDate',
                disable: mode === 'view',
                span: 12,
                format: 'YYYY-MM-DD',
                rules: [{ required: true, message: '请输入签约日期' }],
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: '有效期',
            //     fieldName: 'validityDays',
            //     disable: mode === 'view',
            //     span: 12,
            //     rules:[{ required: true, message: '请输入有效期' }],
            // },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: '截止日期',
                fieldName: 'deadline',
                disable: mode === 'view',
                span: 12,
                format: 'YYYY-MM-DD',
                rules: [{ required: true, message: '请输入截止日期' }],
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '合同类型',
                fieldName: 'contractType',
                disable: mode === 'view',
                span: 12,
                rules: [{ required: true, message: '请输入合同类型' }],
                options: contractTypeOptions,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '返利类型',
                fieldName: 'rebateType',
                disable: mode === 'view',
                span: 12,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '授信保证金',
                fieldName: 'depositAmount',
                disable: mode === 'view',
                precision: 2,
                min: 0,
                span: 12,
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '附件',
                fieldName: 'attachment',
                span: 12,
                colClassName: 'ant-col-h-auto',
                formItem: (
                    <Form.Item
                        name="fileList"
                        label="附件"
                        valuePropName="fileList"
                        getValueFromEvent={normFile}
                        rules={[
                            {
                                required: true,
                                message: '请上传附件信息',
                            },
                        ]}
                    >
                        <Upload
                            name="file"
                            className="AdjustMonthDrawerUpload"
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            // headers={{
                            //     authorization: getToken()
                            // }}
                            listType="picture"
                            fileList={uploadFileList}
                            maxCount={1}
                            // disabled={editModel === 'look'}
                            beforeUpload={(file) => {
                                let fileEnd: string = file.name.substring(file.name.lastIndexOf('.'))
                                // let filetypes: string[] = [".jpg", ".png", ".doc", ".xls", ".pdf", ".docx", ".xlsx", ".mp4", ".mp3"];
                                let filetypes: string[] = ['.jpg', '.png', '.jpeg', 'svg', '.gif', '.pdf', '.doc', '.xls', '.xlsx']
                                // var filetypes = [".jpg", ".png", ".rar", ".txt", ".zip", ".doc", ".ppt", ".xls", ".pdf", ".docx", ".xlsx", ".mp4", ".mp3"];
                                let isType = filetypes?.includes(fileEnd)
                                if (!isType) {
                                    message.error('不支持该格式的上传,当前仅支持 图片、pdf、xls、xlsx和.doc 类型文件')
                                }
                                const isLt20M = file.size / 1024 / 1024 < 20
                                if (!isLt20M) {
                                    message.error('上传到文件不能超过20M')
                                }
                                return isType && isLt20M
                            }}
                            iconRender={(file) => {
                                if (file?.type?.indexOf('image/') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-tupian2" />
                                if (file?.type?.indexOf('pdf') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-pdf" />
                                if (file?.type?.indexOf('msword') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-doc" />
                                if (file?.type?.indexOf('sheet') !== -1 || file?.type?.indexOf('excel') !== -1) return <FileExcelOutlined />
                            }}
                            onChange={(info) => {
                                if (info.file.status === 'done') {
                                    let md5 = info.file.response.retData
                                    let list: UploadFile[] = info.fileList
                                    for (let index = 0; index < list.length; index++) {
                                        let e = list[index]
                                        e.thumbUrl = getBaseImgLookUrl(md5)
                                        e.url = getBaseImgLookUrl(md5)
                                    }
                                    setUploadFileList(info.fileList)
                                }
                            }}
                            onPreview={(file) => {
                                if (
                                    file?.type?.indexOf('pdf') != -1 ||
                                    file?.type?.indexOf('msword') != -1 ||
                                    file?.type?.indexOf('sheet') !== -1 ||
                                    file?.type?.indexOf('excel') !== -1
                                ) {
                                    window.location.href = file?.url ?? ''
                                } else {
                                    setPreviewImage(file?.url)
                                    setPreviewOpen(true)
                                }
                            }}
                        >
                            <Button icon={<UploadOutlined />}>选择文件上传</Button>
                        </Upload>
                    </Form.Item>
                ),
            },
        ],
    }

    const formConfig: IYhFormBox<ISupplierContractDetails> = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: 'right',
        formValues: formValues as ISupplierContractDetails,
        onChange,
        boxs: [baseFormItem],
    }

    return (
        <YHModal
            visible={visible}
            title={mode === 'add' ? '新增供应商合同' : '编辑供应商合同'}
            width={800}
            bodyHeight={500}
            showFooter={true}
            onCancel={handleClose}
            cancelText="关闭"
            okText={mode === 'view' ? '关闭' : '保存'}
            onOk={handleSave}
        >
            <div style={{ padding: '20px' }}>
                <YhFormBox {...formConfig} />
            </div>

            <Image
                width={200}
                style={{ display: 'none' }}
                src={previewImage}
                preview={{
                    visible: previewOpen,
                    src: previewImage,
                    onVisibleChange: (value) => {
                        setPreviewOpen(value)
                    },
                }}
            />
        </YHModal>
    )
}
